import {filter, map} from 'rxjs/operators';
import {coinMarginedContractGray$} from '@/config';
import {uiMsg$} from '@/ui';
import type {FUUserGray} from '@/types';

uiMsg$
  .pipe(
    filter((o: FUUserGray) => o.type === 'coin-margined-contract'),
    map((o) => o.data)
  )
  .subscribe((o) => coinMarginedContractGray$.next(o));
